export const RECOMMENDED_PROTEIN_RATIO = 1;
const NORMAL_PROTEIN_RATIO = 1.25;
const HIGH_PROTEIN_RATIO = 1.5;
const VERY_HIGH_PROTEIN_RATIO = 1.75;
const EXTREME_PROTEIN_RATIO = 2;

export const ProteinRatio = Object.freeze({
    RECOMMENDED_PROTEIN_RATIO,
    NORMAL_PROTEIN_RATIO,
    HIGH_PROTEIN_RATIO,
    VERY_HIGH_PROTEIN_RATIO,
    EXTREME_PROTEIN_RATIO,
});

export const RECOMMENDED_FAT_RATIO = 1;
const LOW_FAT_RATIO = 0.8;
const HIGH_FAT_RATIO = 1.2;

export const FatRatio = Object.freeze({
    LOW_FAT_RATIO,
    RECOMMENDED_FAT_RATIO,
    HIGH_FAT_RATIO,
});
